exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.min-width-50-pct {\n    min-width: 50%;\n}\n", ""]);

// exports
